<template>
	<div class="usermana">
		<!-- 表头 -->
		<div class="button-group">
			<!-- 刷新表单 -->
			<el-button type="success" @click="fetchResourceList">刷新</el-button>
		</div>
		<!-- 表单 -->
		<el-config-provider :locale="zhCn">
			<el-table
				:row-class-name="rowClassName"
				:data="resourceList"
				highlight-current-row
				style="width: 100%; margin-top: 2vh; margin-bottom: 2vh"
			>
				<el-table-column prop="fileName" label="文件名称" />
				<el-table-column prop="fileType" label="资源类型" />
				<el-table-column prop="comment" label="备注" />
				<el-table-column fixed="right" label="内容">
					<template #default="scope">
						<el-button
							link
							type="primary"
							@click="enterresourceButton(scope.row)"
						>
							<template v-if="getIconName(scope.row) === 'video'">
								<el-icon><VideoPlay /></el-icon>
							</template>
							<template
								v-else-if="
									getIconName(scope.row) === 'pptx' ||
									getIconName(scope.row) === 'other'
								"
							>
								<el-icon><DocumentAdd /></el-icon>
							</template>
							<template v-else>
								<!-- 默认图标 -->
								<el-icon><Document /></el-icon>
							</template>
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 页面分页功能 -->
			<el-pagination
				:page-size="limit"
				:total="total"
				v-model:current-page="page"
				@click="fetchResourceList"
			/>
		</el-config-provider>
	</div>
</template>

<script>
import { defineComponent, } from "vue";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";

export default defineComponent({
	data() {
		return {
			courseId: null,
			matterFrom: {
				fileType: "",
			},
			mattersFrom: {
				resourceId: "",
			},

			// 获取资源列表
			filter: {
				fileType: "",	
			},
			resourceList: [],
			page: 1,
			limit: 9,
			total: 0,
			interval: null,
			zhCn,
		};
	},
	// 刷新页面
	async mounted() {
		await this.fetchPublicResourceCourseId(); // 等待获取公共资源课程 ID
		await this.fetchResourceList(); // 等待资源列表加载完成
		this.interval = setInterval(() => {
			this.fetchResourceList(); // 每 5 秒刷新资源列表
		}, 5000);
	},
	unmounted() {
		clearInterval(this.interval);
	},
	setup() {
		const getIconName = (row) => {
			const fileType = row.fileType;
			if (fileType === "mp4") {
				return "video";
			} else if (fileType === "pptx" || fileType === "ppt") {
				return "pptx";
			} else {
				return "other";
			}
		};
		return {
			getIconName,
		};
	},
	methods: {
		// 表格背景
		rowClassName({ rowIndex }) {
			return rowIndex % 2 === 0 ? "even-row" : "odd-row";
		},
		//获取资源表单
		async fetchResourceList() {
			try {
				const response = await this.$axios.post("/api/resource/list", {
					courseId: this.courseId,
					page: this.page,
					limit: this.limit,
					fileType: this.filter.fileType
				});

				this.resourceList = response.data.resourceList; // 根据你的数据结构调整
				console.log("resourceList", this.resourceList);
				this.total = response.data.total;
			} catch (error) {
				console.error("An error occurred while fetching the dev list:", error);
			}
		},

		async enterresourceButton(row) {
			this.mattersFrom.resourceId = row.resourceId;
			this.matterFrom.fileType = row.fileType;
			console.log("22222222", this.matterFrom.fileType);
			if (this.matterFrom.fileType === "mp4") {
				await this.getvideo();
			} else {
				await this.getppt();
			}
		},
		async getvideo() {
			try {
				const response = await this.$axios.post("/api/resource/down", {
					resourceId: this.mattersFrom.resourceId,
				});
				const fileUrl = response.data.fileUrl;
				if (fileUrl) {
					// 使用 params 或 query，这取决于你的路由配置
					this.$router.push({
						name: "studentvideo",
						params: { fileUrl: fileUrl }, // 如果路由使用 params
						// query: { fileUrl: fileUrl }, // 如果路由使用 query
					});
				} else {
					console.error("fileUrl is missing from the response");
				}
			} catch (error) {
				// 处理可能发生的错误
				console.error("获取视频时出错：", error);
				// 可以选择在这里添加错误处理逻辑，比如路由跳转到错误页面等
			}
		},

		async getppt() {
			try {
				const response = await this.$axios.post("/api/resource/down", {
					resourceId: this.mattersFrom.resourceId,
				});
				console.log("1234567", response);
				const fileUrl = response.data.fileUrl;
				console.log("12131", fileUrl);
				if (fileUrl) {
					// 使用 params 或 query，这取决于你的路由配置
					await this.downloadFile(fileUrl);
				} else {
					console.error("fileUrl is missing from the response");
				}
			} catch (error) {
				// 处理可能发生的错误
				console.error("下载PPT时出错：", error);
			}
		},

		async downloadFile(fileUrl) {
			try {
				const windowObjectReference = window.open(
					`${this.$baseFileUrl}${fileUrl}`,
					"_blank",
					"noopener,noreferrer"
				);
				if (!windowObjectReference) {
					throw new Error("无法打开新窗口");
				}
			} catch (error) {
				// 处理可能发生的错误
				console.error("打开文件时出错：", error);
			}
		},

        // 获取公共资料课程id
		async fetchPublicResourceCourseId() {
			try {
				const response = await this.$axios.post("/api/course/public",)
				this.courseId = response.data.courseId
			} catch (error) {
				console.error("Error fetching course list:", error);
			}
		}

	},
});
</script>

<style scoped>
:deep .even-row {
	background-color: #f0f0f0;
	/* 设置偶数行的背景色 */
}

:deep .odd-row {
	background-color: #ffffff;
	/* 设置奇数行的背景色 */
}

.button-group {
	display: flex;
	/* background-color: yellow; */
	height: 4vh;
}

.el-button {
	height: 100%;
	margin-right: 6px;
}

.el-pagination {
	margin-top: 1vh;
	position: absolute;
	bottom: 1vh;
}

.dialog-information {
	margin-bottom: 30px;
	border: 1px solid #ccc;
	border-radius: 5px;
}

.dialog-information-text {
	margin: 10px;
	font-size: 15px;
}

:deep .el-dialog__header {
	margin-right: 0px;
}

:deep .el-dialog__body {
	padding-top: 16px;
}
</style>
